import { Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { ProfileService } from "@barthauer/abc/core/authentication";
import { CompaniesService } from "../../shared/companies/companies.service";
import { AppService } from "../app.service";
import { DataService, ObjectKeys } from "../data.service";

@Injectable({
  providedIn: "root",
})
export class ProfileSelectionGuard implements CanActivate {
  constructor(
    private router: Router,
    private dataService: DataService,
    private companyService: CompaniesService,
    private profileService: ProfileService,
    private appService: AppService
  ) {}

  public readonly projectColumns = [
    this.dataService.coreDataService.createQueryColumn("Id", "Id"),
    this.dataService.coreDataService.createQueryColumn(
      "Designation",
      "Designation"
    ),
    this.dataService.coreDataService.createQueryColumn("ParentId", "ParentId"),
    this.dataService.coreDataService.createQueryColumn(
      "ref:ParentId",
      "CompanyName"
    ),
  ];

  private async setupRoutingData(data): Promise<void> {
    localStorage.setItem("companyName", data.CompanyName);
    localStorage.setItem("currentCompany", data.ParentId);
    localStorage.setItem("projectName", data.Designation);
    localStorage.setItem("projectId", data.Id);
    this.appService.switchTreeViewToCompany(true);
    this.appService.switchTreeViewToProject(true);
    this.companyService.selectedProjectData(data);
    this.dataService.clearRedirectParams();
  }

  async canActivate(): Promise<boolean | UrlTree> {
    const redirectParameters = this.dataService.getRedirectParams();
    const profiles = await this.profileService.getProfilesForCurrentUser().toPromise();
    if (redirectParameters.profileName && redirectParameters.projectId) {
      try {
        const selectedProfile = profiles.find(
          (profile) => profile.displayText === redirectParameters.profileName
        );
        if (selectedProfile) {
          await this.profileService.setCurrentProfile(selectedProfile).toPromise();
          const projectOpath = `Id='${redirectParameters.projectId}'`;
          const project = await this.dataService
            .readObjects(ObjectKeys.PROJECT, this.projectColumns, projectOpath)
            .toPromise();
          await this.setupRoutingData(project[0]);
          return this.router.navigate(["dashboard"]);
        } else {
          return true;
        }
      } catch (error) {
        return true;
      }
    }
    else {
      if (profiles && profiles.length === 1) {
        await this.profileService.setCurrentProfile(profiles[0]).toPromise();
        return this.router.createUrlTree(['/companies']);
      }  else {
        return true;
      }
    }
  }
}
